import CompanyProductListView from "@/views/company/products/CompanyProductListView";
import CompanyProductCreateView from "@/views/company/products/CompanyProductCreateView";
import CompanyProductEditView from "@/views/company/products/CompanyProductEditView";
import CompanyProductDetailView from "@/views/company/products/CompanyProductDetailView";

export default [
  {
    name: "pages.company.products",
    path: "products",
    component: CompanyProductListView
  },
  {
    name: "pages.company.products.create",
    path: "products/create",
    component: CompanyProductCreateView
  },
  {
    name: "pages.company.products.show",
    path: "products/:id",
    component: CompanyProductDetailView
  },
  {
    name: "pages.company.products.edit",
    path: "products/:id/edit",
    component: CompanyProductEditView
  },
];
